import { InputAdornment, MenuItem, TextField, Button } from "@mui/material";
import { useEffect, useState } from "react";
import Strings from "../../../../resources/Strings";
import { isPhoneNumber, isRequired, isSameUserPhoneNumberError } from "../../../../utils/FormUtils";
import { INPUTS_PROPS, DIALING_CODES } from "../../../../enums/Enums";
import { DEFAULT_DIALING_CODE } from "../../../../constants/Constants";
import { phoneNumberToSend, getPhoneNumberDialingCodePrefix, removePhoneNumberPrefix, removeETicketPrefix } from "../../../../utils/CommonUtils";
import { showErrorMessage } from "../../../../utils/MessagesUtils";
import { commonActions } from "../../../../redux/reducers/CommonReducer";
import store from "../../../../redux/Store";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import * as actionsService from "../../../../services/ActionsService/ActionsService";
import Icons from "../../../../resources/icons/Icons";
import classes from "../CustomInputs.module.css";

const PhoneInputWithoutVerification = (props) => {
  const [dialingCode, setDialingCode] = useState(props.isEditMode || props.fromGmt || props.handleVerify ? props.dialingCode : DEFAULT_DIALING_CODE);
  const [isVerifiy, setIsVerifiy] = useState(props.isPhoneVerified); // manages ui green circle mark
  const [errorMessage, setErrorMessage] = useState({ content: "", isValid: true });
  const [isVerificationClicked, setIsVerificationClicked] = useState(false);
  const [isVerifyValidationNeeded, setIsVerifyValidationNeeded] = useState(props.isVerifyValidationNeeded); // // manages the field verify validation


  // existing usage - search on end endornment
  const [phoneNumberError, setPhoneNumberError] = useState({ errorMessage: "", isValid: "" });
  const [isSameUserPhoneVerifiy, setIsSameUserPhoneVerifiy] = useState(true);

  // existing usage
  const handleSearch = () => {
    setIsVerificationClicked(true);
    let res = validatePhoneNumber();
    if (!res) {
      return;
    }

    let fixedFullPhoneNumber = dialingCode + phoneNumberToSend(dialingCode, props.value);
    // validate is user exists in userSites
    let siteIds = props.isGmtUserCreation ? props.selectedSitesIds : props.selectedSites.map(site => site.id); // site => site.selectedSites.id
    actionsService.validatePhoneNumber(fixedFullPhoneNumber, true, (props.handleVerify ? false : true || props.fromGmt ? false : true)).then(response => {
      if(response.data.isSuccess && response.data.entity !== null){
        let foundedUserData = response.data.entity;
        actionsService.validateAllowedNewParkerSites(fixedFullPhoneNumber, siteIds, props.fromGmt, true, props.handleVerify ? false : true || props.fromGmt ? true : false)
        .then((response) => {
        if (response.data.isSuccess) {
          let isParkingFacilitiesFounded = response.data.entity && response.data.entity.length > 0;
          // new parker + facilities is empty
          if (isParkingFacilitiesFounded || props.isGmtUserCreation || props.isAddAllocationProcess) {
            let selectedSitesToUpdate = isParkingFacilitiesFounded ? props.selectedSites?.filter(site => response.data.entity.includes(site.id)) : props.selectedSites;
            // props.selectedSites.filter(site => response.data.entity === site.id) // props.selectedSites.filter(site => response.data.entity.contains(site.id))

            if(isParkingFacilitiesFounded ){
              props.onChange({ ["selectedSites"]: selectedSitesToUpdate });
            } else if(props.isGmtUserCreation){
              let selectedSitesIdsToUpdate = isParkingFacilitiesFounded ? props.selectedSitesIds?.filter(siteId => response.data.entity.includes(siteId)) : props.selectedSitesIds;
              props.onChange({ ["selectedSitesIds"]: selectedSitesIdsToUpdate });
            }

            // when called from existing parking allocation
            if (props.handleVerify) {
              actionsService.validateIsUserExistsInUserSites(fixedFullPhoneNumber, [props.selectedSiteId])
              .then((response) => {
                if (response.data.isSuccess) {
                  if (response?.data?.entity.length > 0) {
                    // continue the process to look for tokens
                    props.handleVerify(foundedUserData);
                  } else {
                    // user doesnt exist for the selected site on userSite
                    props.handleVerify(Strings.INPUT_ERROR_MESSAGES.GMT_USER_NOT_FOUND);
                  }
                }
              })
              .catch((error) => {
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                showErrorMessage(error);
              })
            }

            // if user created from app, when user founded and allowed to the site
            if (!props.fromGmt && foundedUserData !== null) {
              //  if user created from app (no userSites yet), set the userData to form fields
              let isAcceptedMobileTermsAndPolicies = false;
              if (foundedUserData?.utronUser?.userAdditionalData?.length > 0) {
                isAcceptedMobileTermsAndPolicies = foundedUserData?.utronUser?.userAdditionalData[0] !== null ? 
                foundedUserData?.utronUser?.userAdditionalData[0]?.isAcceptedMobileTermsAndPolicies : false;
              }

              let isETicketUser = foundedUserData?.userIdentity?.isETicketUser;
              let isUserCreatedFromApp = foundedUserData?.utronUser?.userSites?.length === 0 && isAcceptedMobileTermsAndPolicies;
              if (isUserCreatedFromApp || isETicketUser) {
                updateUserData(foundedUserData, {isUserCreatedFromApp, isETicketUser});
                setIsVerifiy(true);
              }
              else {
                // if not created from app and founded 
                // parker already exists & cannot use this phone number
                // if called from existing - won't be set
                if (!props.handleVerify) {
                  setIsVerifiy(false);
                  setErrorMessage({
                    content: Strings.INPUT_ERROR_MESSAGES.PARKER_ALREADY_EXISTS, 
                    isValid: false 
                  });
                }
              }
            }

            // if fromGmt case and user is founded, set the userData to form fields
            if (props.fromGmt && foundedUserData !== null) {
              updateUserData(foundedUserData);
              setIsVerifiy(true);
            }     
          } 
          else {
            // gmt user already exists as a parker on the selected site
            setErrorMessage({
               content: Strings.INPUT_ERROR_MESSAGES.PARKER_ALREADY_EXISTS, 
               isValid: false 
            });
          }
        } 
        else {
          // any other error message from response
          setErrorMessage({
            content: response.data?.error?.errorTitle, 
            isValid: false 
          });
        }
      });
      }else {
        // user not found
        // when called from existing parking allocation
        // if the error occurs - pass the message into the existing allocation message card
        if (props.handleVerify) {
          props.handleVerify(Strings.INPUT_ERROR_MESSAGES.GMT_USER_NOT_FOUND);
        }
        
        // user not found on add new parker, phone available for use 
        if (!props.fromGmt) {
          setIsVerifiy(true); // show verify icon
          //props.onChange({ ["isPhoneVerified"]: true }); // show verify icon
        }
        else {
          setErrorMessage({
            content: Strings.INPUT_ERROR_MESSAGES.USER_NOT_FOUND, 
            isValid: false 
          });
        }

        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    }).catch((error) => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      showErrorMessage(error);
    });
  };

  const validatePhoneNumber = () => {
    // check to use existing validation
    let fixedPhone = dialingCode + phoneNumberToSend(dialingCode, props.value);
    let isRequiredRes = isRequired(props.value);
    let phoneNumberError;
    let isExistingPhoneValid = props.existingPhoneNumberValidation ? props.existingPhoneNumberValidation() : true;

    if(!isRequiredRes.isValid){
      phoneNumberError = isRequiredRes;
    }else if (!isExistingPhoneValid){
      phoneNumberError = isSameUserPhoneNumberError()
      setIsSameUserPhoneVerifiy(phoneNumberError?.isValid)
    }
    else{
      phoneNumberError = isPhoneNumber(fixedPhone);
    } 
    setPhoneNumberError(phoneNumberError);
    return phoneNumberError?.isValid;
  };

  const handleDialingCodeChange = (event) => {
    if (props.dialingCode) {
      // set dialing code in formData and clear phone input
      props.onChange({ 
        [INPUTS_PROPS.DIALING_CODE]: event.target.value,
        [INPUTS_PROPS.PHONE_NUMBER]: ""
      });
    }


    setDialingCode(event.target.value);
  };

  useEffect(() => {
    // reset call to server error messages
    setErrorMessage({ content: "", isValid: true });

    if (props.handleError) {
      setIsVerificationClicked(false);
      // props.onChange({ [props.phoneVerifiedId]: isVerifiy });
      props.handleError({
        [props.id]: props.hasError,
        [props.phoneVerifiedId]: isVerifyValidationNeeded && !isVerifiy, //[props.phoneVerifiedId]: !isVerifiy,
      });
    }
  }, [props.value, isVerifiy]);

  const handleChange = (event) => {
    const { name, value } = event.target ? event.target : event;
    let newPhone = value;
    if (value !== props.value) {
      // if (!value.startsWith(dialingCode)) {
      //   newPhone = dialingCode + value;
      // }
      setIsVerifiy(false);

      var fixedFullPhoneNumber = newPhone;
      props.onChange({ [name]: fixedFullPhoneNumber });
    }
  };

  const getHelperText = () => {
    let isExistingPhoneValid = props.existingPhoneNumberValidation ? props.existingPhoneNumberValidation() : true;
    if ((props.isStepSubmitted || isVerificationClicked) && props.hasError) {
      return props.errorMessage;
    }
    if ((props.isStepSubmitted || isVerificationClicked) && !isExistingPhoneValid) /*props.isStepSubmitted && !isExistingPhoneValid*/ {
      return Strings.INPUT_ERROR_MESSAGES.INVALID_SAME_PHONE; /*phoneNumberError?.errorMessage*/
    }
    // verify check only on new parker case
    if ((props.isStepSubmitted) && (/*!props.fromGmt*/ isVerifyValidationNeeded && !isVerifiy)) {
      return Strings.INPUT_ERROR_MESSAGES.PHONE_NOT_VERIFIED; 
    }
  };

  const hasError = () => {
    let isExistingPhoneValid = props.existingPhoneNumberValidation ? props.existingPhoneNumberValidation() : true;
    return (
      ((props.isStepSubmitted || isVerificationClicked) && props.hasError) ||
      ((props.isStepSubmitted || isVerificationClicked) && !isExistingPhoneValid) ||
      ((props.isStepSubmitted) && (/*!props.fromGmt*/ isVerifyValidationNeeded && !isVerifiy)) // verify field check only on new parker case
    );
  };

  // used for 'fromGmt' - sets the founded user data to the form fields
  const updateUserData = (userEntity, extraData = null) => {
    let utronUser = userEntity?.utronUser;
    let userIdentity = userEntity?.userIdentity;
    if (utronUser && userIdentity) {
      let newObjData = {
        //[INPUTS_PROPS.FROM_GMT]: false,
        [INPUTS_PROPS.CARS]: extraData?.isUserCreatedFromApp ? utronUser?.cars : extraData?.isETicketUser ? removeETicketPrefix(utronUser?.cars) : [],
        [INPUTS_PROPS.IS_ETICKET_USER]: extraData?.isETicketUser,
        [INPUTS_PROPS.IS_USER_CREATED_FROM_APP]: extraData?.isUserCreatedFromApp,
        [INPUTS_PROPS.IS_GMT_USER]: true,
        [INPUTS_PROPS.EXSIST_USER]: utronUser,
        [INPUTS_PROPS.PHONE_VERIFIED]: true,
        [INPUTS_PROPS.DIALING_CODE]: getPhoneNumberDialingCodePrefix(userEntity?.userIdentity.phoneNumber),
        [INPUTS_PROPS.FIRST_NAME]: extraData?.isETicketUser ? '' : utronUser.firstName,
        [INPUTS_PROPS.LAST_NAME]: extraData?.isETicketUser ? '' : utronUser.lastName,
        [INPUTS_PROPS.PROFILE_PICTURE]: utronUser.image,
        [INPUTS_PROPS.EMAIL]: extraData?.isETicketUser ? '' : userIdentity.email,
        [INPUTS_PROPS.EXSIST_USER_IDENTITY]: userIdentity,
      };
      let additionalData = utronUser.userAdditionalData;
      if(additionalData && additionalData[0]){
        let kioskLoginName = additionalData[0].kioskLoginName;
        let kioskPIN = additionalData[0].kioskPIN;
        let isAcceptedMobileTermsAndPolicies = additionalData[0].isAcceptedMobileTermsAndPolicies;
        let notes = additionalData[0].notes;
        let isMessagingEnabled = additionalData[0].isMessagingEnabled;

        if(kioskLoginName &&  kioskLoginName !== null){
          newObjData[INPUTS_PROPS.PERSIONAL_ID] = kioskLoginName;
        }
        if(kioskPIN &&  kioskPIN !== null){
          newObjData[INPUTS_PROPS.PERSIONAL_PIN] = kioskPIN;
        } 
        if(isAcceptedMobileTermsAndPolicies && isAcceptedMobileTermsAndPolicies !== null){
          newObjData[INPUTS_PROPS.IS_ACCEPTED_MOBILE_TERMS_AND_POLICIES] = isAcceptedMobileTermsAndPolicies;
        } 
        if(notes && notes !== null) {
          newObjData[INPUTS_PROPS.NOTES] = notes;
        }
        if (isMessagingEnabled !== null) {
          newObjData[INPUTS_PROPS.IS_MESSAGING_ENABLED] = isMessagingEnabled;
        }
      }
      props.onChange(newObjData);
    }
  };

  return (
    <div className={classes.customTextField}>
      <TextField
        fullWidth
        label={props.label}
        id={props.id}
        name={props.id}
        disabled={props.disabled}
        className={classes.textField}
        //defaultValue={removePhoneNumberPrefix(props.value)}
        value={props.value}
        onChange={handleChange}
        error={hasError()}
        helperText={getHelperText()}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          classes: {
            notchedOutline: classes.filed,
          },
          endAdornment: (
            <span className={classes.endAdornment}>
              {!isVerifiy && (
                <Button
                className={classes.inputButton}
                onClick={handleSearch}
              >
                {props.actionText}
              </Button>
              )}
              {isVerifiy && (
                <Button className={classes.inputButton}>
                  <CheckCircleOutlineOutlinedIcon color="success" />
                </Button>
              )}
              {/* {!showVerificationMessage && !props.isPhoneVerified && (
                <Button
                  className={classes.inputButton}
                  onClick={sendVerificationCode}
                >
                  {props.actionText}
                </Button>
              )}
              {props.isPhoneVerified && (
                <Button className={classes.inputButton}>
                  <CheckCircleOutlineOutlinedIcon color="success" />
                </Button>
              )} */}
            </span>
          ),
          startAdornment: (
            <InputAdornment position="start">
              <TextField
                id="outlined-select-currency"
                select
                value={dialingCode}
                onChange={handleDialingCodeChange}
                InputProps={{
                  classes: { notchedOutline: classes.dialingCode },
                }}
              >
                <MenuItem
                  key={DIALING_CODES.US.toString()}
                  value={DIALING_CODES.US}
                >
                  <img src={Icons.USA_FLAG} />
                </MenuItem>
                <MenuItem
                  key={DIALING_CODES.IL.toString()}
                  value={DIALING_CODES.IL}
                >
                  <img src={Icons.ISRAEL_FLAG} />
                </MenuItem>
              </TextField>
              +{dialingCode}
            </InputAdornment>
          ),
        }}
        FormHelperTextProps={{
          classes: {
            error: classes.error,
          },
        }}
      />
      {!errorMessage?.isValid && <div className={classes.error}>{errorMessage.content}</div>}
    </div>
  );
};

export default PhoneInputWithoutVerification;
